// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__BKy-5","rootCenter":"LoadMoreObserver_rootCenter__3NQCX","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2kkrn"};